// extracted by mini-css-extract-plugin
export default {"tupacGrid":"mm-z","tupacHeader":"nm-z","tupacHeader2":"om-z","tupacMenu":"pm-z","tupacMenu2":"qm-z","tupacMain":"rm-z","tupacMain2":"sm-z"};